import { useEffect, useState } from 'react'
import Slides from '../slides/Slides'
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/authContext';
import Swal from 'sweetalert2';
import { WebService } from '../../services/webService';

const Cursos = ({M}) => {
   const [cursos,setCursos] = useState();
   const { logout, nominaID } = useAuthContext();
   const handleLogout = (e) => {
      logout();
   };
   const getCursos = async () => {
      try {
         const data = await WebService.getCursos(nominaID);
         setCursos(data || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudieron cargar los cursos",
            confirmButtonColor: "#147B9C",
         });
      }
   };
   const handleRealizado = (e) => {
      Swal.fire({
         icon: 'warning',
         title: '¡Atención!',
         text: 'Ud. Ya realizo la capacitación',
         showConfirmButton: true,
         confirmButtonText: "Ok",
      });
   }
   useEffect(() => {
      getCursos();
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"capacitacion"}/>
         {/* <div className="section animated fadeIn">
            <div className="row center">
               <div className="container center">
                  <div className="row">
                     <div className="col s12 m12">
                        <div className="alert alert-success">
                           ¡Mirá los videos, respondé el cuestionario y obtené el <strong>certificado</strong> para acreditar que participaste en la Capacitación!
                        </div>
                     </div>
                  </div>
                  <div className="row">
                     <div className="col s12 m12 center-align">
                        <Link className="btn waves-effect waves-light red accent-3" onClick={()=>handleLogout()}>Salir
                           <i className="material-icons right">send</i>
                        </Link>
                     </div>
                  </div>
                  <div className="row">
                  {cursos?.map((c,index) => {
                     return(
                        <div key={index} className="col s12 m6">
                           <div className="card blue-grey darken-1">
                              <div className="card-content white-text">
                                 <span className="card-title">{c.curso_titulo}</span>
                                 <p>{c.curso_descripcion}</p>
                              </div>
                              <div className="card-action">
                                 <Link to={`videos/${c.curso_id}`}>Videos</Link>
                                 {c.status ?
                                    <Link onClick={()=>handleRealizado()}>Cuestionario</Link>
                                    :
                                    <Link to={`cuestionario/${c.curso_id}`}>Cuestionario</Link>
                                 }
                              </div>
                           </div>
                        </div>
                     )
                  })}
                  </div>
               </div>
            </div>
         </div> */}
         <div className="section animated fadeIn" style={{ padding: '20px 0' }}>
            <div className="row center">
               <div className="container center">
                  
                  {/* ALERTA INFORMATIVA */}
                  <div className="row">
                     <div className="col s12 m12">
                        <div className="card-panel teal lighten-5 teal-text text-darken-4 z-depth-1" style={{ borderRadius: '12px', borderLeft: '5px solid #00acc1' }}>
                           <span style={{ fontSize: '1.05rem', fontWeight: '500' }}>
                              ¡Mirá los videos, respondé el cuestionario y obtené el <strong>certificado</strong> para acreditar que participaste en la Capacitación!
                           </span>
                        </div>
                     </div>
                  </div>

                  {/* BOTÓN DE SALIDA */}
                  <div className="row" style={{ marginBottom: '30px' }}>
                     <div className="col s12 m12 center-align">
                        <button 
                           onClick={handleLogout} 
                           className="btn waves-effect waves-light red accent-3 hoverable"
                           style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 28px', height: '42px', lineHeight: '42px' }}
                        >
                           Salir
                           <i className="material-icons right" style={{ marginLeft: '6px' }}>exit_to_app</i>
                        </button>
                     </div>
                  </div>

                  {/* LISTADO DE CURSOS */}
                  <div className="row">
                     {cursos?.map((c, index) => {
                        return (
                           <div key={index} className="col s12 m6">
                              <div className="card z-depth-2 hoverable" style={{ borderRadius: '12px', overflow: 'hidden', border: 'none' }}>
                                 <div className="card-content white-text left-align" style={{ backgroundColor: '#37474f', padding: '30px' }}>
                                    <span className="card-title" style={{ fontWeight: '700', fontSize: '1.4rem', marginBottom: '15px' }}>
                                       {c.curso_titulo}
                                    </span>
                                    <p style={{ lineHeight: '1.6', opacity: '0.9', fontSize: '1rem' }}>
                                       {c.curso_descripcion}
                                    </p>
                                 </div>
                                 <div className="card-action" style={{ backgroundColor: '#263238', borderTop: 'none', padding: '15px 30px', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                    <Link 
                                       to={`videos/${c.curso_id}`} 
                                       className="waves-effect waves-light btn-small light-blue accent-3 white-text"
                                       style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', boxShadow: 'none' }}
                                    >
                                       <i className="material-icons left" style={{ marginRight: '4px' }}>play_circle_outline</i>
                                       Videos
                                    </Link>

                                    {c.status ? (
                                       <Link 
                                          onClick={handleRealizado} 
                                          className="waves-effect waves-light btn-small grey darken-1 white-text"
                                          style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', boxShadow: 'none' }}
                                       >
                                          <i className="material-icons left" style={{ marginRight: '4px' }}>check_circle</i>
                                          Cuestionario
                                       </Link>
                                    ) : (
                                       <Link 
                                          to={`cuestionario/${c.curso_id}`} 
                                          className="waves-effect waves-light btn-small teal accent-4 white-text"
                                          style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', boxShadow: 'none' }}
                                       >
                                          <i className="material-icons left" style={{ marginRight: '4px' }}>quiz</i>
                                          Cuestionario
                                       </Link>
                                    )}
                                 </div>
                              </div>
                           </div>
                        );
                     })}
                  </div>

               </div>
            </div>
         </div>
      </>
   )
}

export default Cursos